{
  "surface": "#f8f8f7",
  "ink": "#0f0f0f",
  "brand": "#163f37",
  "brand-dark": "#112f29",
  "brand-hover": "#3a6d63",
  "warm": "#d9e1d0",
  "muted": "#62675d",
  "border": "#9da497",
  "soft": "#ebebe6",
  "white": "#ffffff",
  "button": "#262626",
  "button-hover": "#1c4f45",
  "control-disabled": "#8e8e8e",
  "arrow-hover": "#578a80",
  "control-focus-border": "2.5px",
  "outline": "#171717",
  "body-font": "'Geist Variable', sans-serif",
  "mono-font": "'Geist Mono Variable', monospace",
  "body-size": "16px",
  "body-line": "1.35",
  "body-tracking": "0.01em",
  "small-size": "14px",
  "small-line": "1.4",
  "h1-size": "48px",
  "h1-line": "1.1",
  "h2-size": "40px",
  "h2-line": "1.15",
  "h2-tracking": "0.01em",
  "h3-size": "32px",
  "h3-line": "1.2",
  "h4-size": "24px",
  "h4-line": "1.3",
  "h5-size": "20px",
  "h5-line": "1.3",
  "display-size": "64px",
  "display-line": "1",
  "number-size": "128px",
  "number-line": "1.2",
  "number-tracking": "0.02em",
  "caption-size": "15px",
  "caption-line": "1.15",
  "outer-width": "1320px",
  "content-width": "1096px",
  "article-width": "762px",
  "desktop-inset": "60px",
  "mobile-inset": "20px",
  "grid-gap": "20px",
  "button-border": "1.5px",
  "button-y": "12px",
  "button-x": "24px",
  "section-space": "160px",
  "mobile-section-space": "80px",
  "motion-entry": "1.2s",
  "motion-gallery": "1.5331528186798096s",
  "motion-shape": "1.022101879119873s",
  "motion-photo": "1.2501229047775269s",
  "error": "#9c2934",
  "mobile-h1-size": "40px",
  "mobile-h1-line": "1.15",
  "mobile-h2-size": "36px",
  "mobile-h2-line": "1.1",
  "mobile-h3-size": "28px",
  "mobile-h3-line": "1.15",
  "mobile-h4-size": "22px",
  "mobile-h4-line": "1.25",
  "mobile-h5-size": "18px",
  "mobile-h5-line": "1.35",
  "mobile-number-size": "82px",
  "mobile-number-tracking": "-0.02em",
  "micro-size": "12px",
  "tablet-number-size": "80px",
  "tablet-time-size": "70px",
  "regular-weight": "400",
  "medium-weight": "500",
  "semibold-weight": "600",
  "bold-weight": "700",
  "filter-weight": "550",
  "accent": "#a0edde",
  "design-width": "1440px",
  "film-max-width": "2560px",
  "header-height": "104px",
  "mobile-header-height": "84px"
}
